import { mapActions } from "vuex";

export default {
	methods: {
		...mapActions([
			"changeShowLoadingOverlay"
		]),
		async checkOwnership() {
			const draftId = this.$route.query.draft;

			this.cleanupBuilds();
			if ((localStorage.getItem("builds") || "").includes(draftId)) {
				return true;
			}

			const { data } = await axios({
				url: `/validate-build-user/${draftId}`,
				headers: {
					token: CONFIG.SESSION
				}
			});

			if (data.is_owner) {
				localStorage.setItem("builds", (localStorage.getItem("builds") || "") + `${draftId}|`);
			}

			return data.is_owner;
		},
		cleanupBuilds() {
			const builds = (localStorage.getItem("builds") || "").split("|");

			// 101 due to the pipe (|) at the end of the string.
			// Get rid of the first 50 elements to keep a sizeable amount.
			if (builds.length >= 101) {
				builds.splice(0, 50);
			}

			// No need to add pipe at end, since it's space is already reserved by
			// an empty string.
			localStorage.setItem("builds", builds.join("|"));
		},
		duplicateBuild() {
			this.changeShowLoadingOverlay(true);

			return axios({
				url: `/drafts/${this.$route.query.draft}/influencer?session=${CONFIG.SESSION}`,
				method: "POST",
				responseType: "json"
			}).then(response => {
				const newDraftId = response.data;
				this.$store.dispatch("changeUserDraftId", newDraftId);
				localStorage.setItem("session-draft", newDraftId);
				this.$router.push({
					name: "step4",
					query: {
						price: this.$route.query.price,
						draft: newDraftId
					}
				});
			}).finally(() => {
				this.changeShowLoadingOverlay(false);
			});
		},
		getSessionData() {
			return axios({
				url: `/details/2000/${this.$store.state.User.draftId}?session=${CONFIG.SESSION}`,
				responseType: "json"
			}).then(response => {
				this.$store.dispatch("setBuildPrice", response.data.total);
				this.$store.dispatch("changeSessionDataInfo", response.data);
				this.$store.dispatch("changeSessionGamesData", response.data.fps);
				this.$store.dispatch("changeDraftId", response.data.draftId);
				this.$store.dispatch("setActiveBuild", response.data.defaultBuild);

				if (response.data.rules) {
					this.$store.dispatch("changeActiveRules", response.data.rules);
				}
			}).catch(() => {
				toastr.warning("We could not find your build, please create a new one.", "Build not found");
				this.$router.push({ name: "step1" });
			}).finally(() => {
				this.changeShowLoadingOverlay(false);
			});
		}
	}
};